export default {
  screens: [
    {
      type: 'intro',
      title: '메종의 뮤즈, 조세핀',
      content:
        '1805년에 쇼메를 공식 주얼러로 임명한 조세핀 황후는 메종에게 큰 영감을 주었습니다.',
      idYt: 'gQZPa0SdueQ',
      videoCover: 'world/josephine/video.jpg',
      desktop: {
        cover: 'world/josephine/cover-1.jpg'
      },
      mobile: {
        cover: 'world/josephine/mobile-cover-1.jpg',
        contentStyle: { width: '95%' },
        titleStyle: { width: '60%' },
        coverStyle: {
          width: 'auto',
          width: '50%',
          bottom: '0',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'memento',
      img: 'world/josephine/memento.jpg',
      content:
        '천혜의 자연을 간직한 마르티니크 섬에서 태어난 조세핀은 평생 이국적이며 다양한 스타일을 추구했습니다.<br/><br/> 예술, 패션, 장식, 식물학에 대한 천부적인 감각과 재능을 지녔던 그녀는 당대의 스타일 아이콘으로 여겨졌습니다.',
      cover: 'world/josephine/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/cover-3.jpg'
      },
      mobile: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/mobile-cover-3.jpg',
        coverStyle: {
          width: '62%',
          top: '41%',
          left: '-19%',
          right: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '조세핀의 남다른 스타일 감각은 쇼메의 작품에 끊임없이 영감을 불어넣었으며, 그녀의 이름을 딴 링 컬렉션이 탄생하기도 했습니다.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/kr/worlds/josephine.js